import React from 'react';

/**
 * Template 4: Metric Cards + Face
 * Person on left pointing, floating UI metric cards on right.
 * Blue/light bg. Red arrow connecting cards.
 *
 * Inspired by: "Ad Spend $1.8M → Revenue $22,364,571"
 */
export default function JH_MetricCards({
  headline = '',
  personImage,
  bgColor = '#4A90D9',
  accentColor = '#FFD700',
  metrics = [
    { label: 'Ad Spend', value: '$1.8M' },
    { label: 'Revenue', value: '$22,364,571' },
  ],
}) {
  const isLightBg = isLightColor(bgColor);

  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: bgColor, fontFamily: "'Inter', sans-serif",
    }}>
      {/* Person - left */}
      {personImage ? (
        <div style={{
          position: 'absolute', left: 0, bottom: 0, width: 540, height: 720, zIndex: 2,
        }}>
          <img src={personImage} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center' }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', left: 30, bottom: 0, width: 460, height: 640,
          background: 'rgba(255,255,255,0.1)', borderRadius: '12px 12px 0 0',
          zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 36, color: 'rgba(255,255,255,0.2)',
        }}>PHOTO</div>
      )}

      {/* Metric cards - right side, stacked */}
      <div style={{
        position: 'absolute', right: 60, top: 80, width: 560, zIndex: 1,
        display: 'flex', flexDirection: 'column', gap: 24,
      }}>
        {metrics.map((m, i) => (
          <div key={i} style={{
            background: '#FFFFFF', borderRadius: 16, padding: '24px 36px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          }}>
            <div style={{
              fontSize: 22, fontWeight: 600, color: '#666', marginBottom: 4,
            }}>{m.label}</div>
            <div style={{
              fontSize: i === metrics.length - 1 ? 64 : 48,
              fontWeight: 900, color: '#111', letterSpacing: '-1px',
            }}>
              {/* Highlight the value of the last metric */}
              {i === metrics.length - 1 ? (
                <span style={{
                  background: accentColor, padding: '0 12px',
                  color: isLightColor(accentColor) ? '#111' : '#fff',
                }}>{m.value}</span>
              ) : m.value}
            </div>
          </div>
        ))}

        {/* Arrow between cards */}
        {metrics.length >= 2 && (
          <div style={{
            position: 'absolute', right: -30, top: '40%',
            fontSize: 48, color: '#E53935', transform: 'rotate(90deg)',
            zIndex: 3,
          }}>&#10549;</div>
        )}
      </div>
    </div>
  );
}

function isLightColor(color) {
  const hex = (color || '#000').replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const toL = c => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  return 0.2126 * toL(r) + 0.7152 * toL(g) + 0.0722 * toL(b) > 0.35;
}
